import { render, staticRenderFns } from "./onboardHeader.vue?vue&type=template&id=5844f20e&scoped=true"
import script from "./onboardHeader.vue?vue&type=script&lang=js"
export * from "./onboardHeader.vue?vue&type=script&lang=js"
import style0 from "./onboardHeader.vue?vue&type=style&index=0&id=5844f20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844f20e",
  null
  
)

export default component.exports